module.exports = __webpack_public_path__ + "img/no-mobile.e2bf4af5.png";